module.exports = __webpack_public_path__ + "static/media/isometrics-tile.691feec5.png";